<template>
	<div class="student-base">
		<router-view/>
	</div>
</template>

<script>
export default {
  name: 'StudentBase',
	components: {
	},
  data () {
    return {
    }
  },
	methods: {
	}
}
</script>

<style lang="scss" scoped>
</style>
